export default __webpack_public_path__ + "static/media/Partner---Main-page---final.6695bc85.png";